import React, { useEffect }  from 'react';
import { Link } from 'react-router-dom';
import WOW from "wowjs";


function WorkingProcess() {
    useEffect(() => {
        const wow = new WOW.WOW({
          live: false, // This disables continuous scanning for new elements
        });
        wow.init();
      }, []);
  return (
    <div>
        <div className="tpm-services-process-area tmp-section-gap pt-3">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="section-head">
                    <div className="section-sub-title center-title">
                        <img src="assets/images/services/section-custom-menubar.png" alt="Corporate_service" />
                        <span className="subtitle">OUR work process</span>
                    </div>
                    <h2 className="title split-collab">How We Work</h2>
                    </div>
                </div>
            </div>

            <div className="row g-5">
                <div className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".1s">
                    <div className="single-services">
                    <div className="services-inner">
                        <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        <Link to="#">
                            <img src="assets/images/services/services-round-1.png" alt="Business consulting services" />
                        </Link>
                        <div className="number-bg-round">
                            <span>01</span>
                        </div>
                        </div>
                        <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">Consultation & Needs Assessment</h5>
                        <p className="description">
                            We begin with a detailed meeting to understand your business goals, financial structure, and challenges. This helps us identify opportunities for improvement and tailor solutions that align with your specific needs.
                        </p>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                    <div className="single-services">
                    <div className="services-inner">
                        <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        <Link to="#">
                            <img src="assets/images/services/services-round-2.png" alt="Business consulting services" />
                        </Link>
                        <div className="number-bg-round">
                            <span>02</span>
                        </div>
                        </div>
                        <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">Strategy & Planning</h5>
                        <p className="description">
                            Once we understand your requirements, our experts develop a personalized strategy covering accounting, bookkeeping, payroll, and tax planning. Every plan is designed to optimize efficiency and ensure compliance with financial regulations.
                        </p>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".3s">
                    <div className="single-services">
                        <div className="services-inner">
                            <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                            <Link to="#">
                                <img src="assets/images/services/services-round-3.png" alt="Business consulting services" />
                            </Link>
                            <div className="number-bg-round">
                                <span>03</span>
                            </div>
                            </div>
                            <div className="services-content services-content-style-1 text-center">
                            <h5 className="title">Implementation & Ongoing Support</h5>
                            <p className="description">
                                We put the plan into action with precision and transparency. Our team provides continuous support, regular updates, and insights to keep your finances organized, your operations smooth, and your business on the path to growth.
                            </p>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default WorkingProcess





